import {
  Add as AddIcon,
  CloseOutlined as CloseOutlinedIcon,
} from "@mui/icons-material";
import { Button, Slider, TextField, Typography } from "@mui/material";
import {memo, useEffect, useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";

import ActiveFilterIndicator from "./ActiveFilterIndicator";

const MIN_VALUE = 0;
const DEFAULT_VALUE = 25;
const MAX_VALUE = 100;

const SingleValueSliderFilter = ({
  fieldName,
  title,
  currentValue,
  isActive,
  updateFilter,
  minValue = MIN_VALUE,
  maxValue = MAX_VALUE,
  defaultValue = DEFAULT_VALUE,
  setToDefaultOnClear = false,
}) => {
  const resolvedDefaultValue =
    defaultValue < minValue ? minValue : defaultValue;

  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(resolvedDefaultValue);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isEditing) {
      setLocalValue(currentValue ?? resolvedDefaultValue);
    }
  }, [currentValue, resolvedDefaultValue, isEditing]);

  const handleSliderChange = (_, newValue) => {
    setLocalValue(newValue);
    setError("");
  };

  const handleInputChange = (e) => {
    setError("");
    const val = Number(e.target.value);
    console.log(val);
    if (!Number.isNaN(val) && ((!val) || (val >= minValue && val <= maxValue))) {
      if(!val && val < minValue){
        setLocalValue(minValue);
        return;
      }
      setLocalValue(val);
    }
  };

  const handleSave = () => {
    if (localValue < minValue || localValue > maxValue) {
      setError(`The value needs to be within the range ${minValue} - ${maxValue}`);
      return;
    }
    updateFilter(fieldName, localValue);
    setIsEditing(false);
  };

  const handleClear = () => {
    setError("");
    updateFilter(fieldName, setToDefaultOnClear ? resolvedDefaultValue : undefined);
    setLocalValue(resolvedDefaultValue);
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true)
  }

  const renderLabel = () => (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="w-full">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex flex-row items-baseline">
            <span className="pr-2 text-black">{title}</span>
            {isActive && <ActiveFilterIndicator />}
          </div>
          <AddIcon className="text-sky-600" />
        </div>
        <div className="flex flex-row justify-between items-center w-full">
          <span className="text-sky-600">{localValue}</span>
        </div>
      </div>
    </div>
  );

  if (!isEditing) {
    return (
      <Button
        onClick={handleEdit}
        className="justify-between w-full p-0 mb-2 normal-case"
      >
        {renderLabel()}
      </Button>
    );
  }

  return (
    <div className="flex flex-col w-full gap-3 mb-2">
      <div>
        <span className="text-sm font-medium text-black">{title}</span>

        <div className="flex flex-row items-center w-full gap-2">
          <Slider
            value={localValue}
            min={minValue}
            max={maxValue}
            step={1}
            valueLabelDisplay="auto"
            onChange={handleSliderChange}
            className="flex-1 mr-2"
            sx={{
              color: error ? HNSColors.failure[500] : undefined,
            }}
          />

          <TextField
            type="number"
            size="small"
            value={localValue}
            onChange={handleInputChange}
            className="w-20"
            inputProps={{
              min: minValue,
              max: maxValue,
              step: 1,
            }}
          />
        </div>

        {error && (
          <Typography
            className="text-xs"
            style={{ color: HNSColors.failure[500] }}
          >
            {error}
          </Typography>
        )}
      </div>

      <div className="flex justify-end gap-2">
        <Button
          onClick={handleSave}
          className="text-sm text-purple-600 hover:bg-purple-600 hover:text-white"
        >
          Save
        </Button>
        <Button
          onClick={handleClear}
          className="text-sm text-red-600 hover:bg-red-600 hover:text-white"
        >
          <CloseOutlinedIcon />
        </Button>
      </div>
    </div>
  );
};
export default memo(SingleValueSliderFilter);